import React, { useState, useRef, useEffect } from "react";

const FilterSelect = ({
  changeFunc,
  valName,
  filtersArr,
  selectedIds = [],
  onRemove,
  onSelectAll,
  onClearAll,
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const filtered = filtersArr.filter((f) =>
    f.name?.toLowerCase().includes(search.toLowerCase()),
  );

  // רק מה שמוצג כרגע
  const visibleIds = filtered.map((f) => f.id);

  const allVisibleSelected =
    visibleIds.length > 0 && visibleIds.every((id) => selectedIds.includes(id));

  const count = selectedIds.filter((id) =>
    filtersArr.some((f) => f.id === id),
  ).length;

  const toggle = (id) => {
    if (selectedIds.includes(id)) {
      onRemove(id);
    } else {
      changeFunc(id);
    }
  };

  const handleSelectAll = () => {
    const toAdd = visibleIds.filter((id) => !selectedIds.includes(id));

    if (toAdd.length > 0) {
      onSelectAll(toAdd);
    }
  };

  const handleClearAll = () => {
    const toRemove = visibleIds.filter((id) => selectedIds.includes(id));

    if (toRemove.length > 0) {
      onClearAll(toRemove);
    }
  };

  return (
    <div className="fsm-wrapper" ref={ref}>
      <button
        className={`fsm-trigger ${count > 0 ? "fsm-trigger--active" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>
          {valName}
          {count > 0 && <span className="fsm-badge">{count}</span>}
        </span>
        <span className="fsm-arrow">{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div className="fsm-dropdown">
          <div className="fsm-search-row">
            <input
              autoFocus
              className="fsm-search"
              placeholder={`חיפוש ${valName}...`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="fsm-actions-row">
            <button
              className="fsm-action-btn fsm-action-btn--select"
              onClick={handleSelectAll}
              disabled={allVisibleSelected || visibleIds.length === 0}
            >
              ✓ בחר הכל
            </button>

            <button
              className="fsm-action-btn fsm-action-btn--clear"
              onClick={handleClearAll}
              disabled={
                visibleIds.filter((id) => selectedIds.includes(id)).length === 0
              }
            >
              ✕ נקה הכל
            </button>
          </div>

          <div className="fsm-list">
            {filtered.length === 0 ? (
              <div className="fsm-empty">לא נמצאו תוצאות</div>
            ) : (
              filtered.map((f) => {
                const checked = selectedIds.includes(f.id);

                return (
                  <label
                    key={f.id}
                    className={`fsm-option ${
                      checked ? "fsm-option--checked" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => toggle(f.id)}
                      className="fsm-checkbox"
                    />
                    {f.name}
                  </label>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterSelect;
